import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthLayout } from '../layouts/AuthLayout';
import { DashboardLayout } from '../layouts/DashboardLayout';
import { Login } from '../pages/Login';

import { Dashboard } from '../pages/Dashboard';
import { Campaigns } from '../pages/Campaigns';
import { Templates } from '../pages/Templates';
import { Recipients } from '../pages/Recipients';
import { Lists } from '../pages/Lists';
import { ListDetail } from '../pages/ListDetail';
import { Analytics } from '../pages/Analytics';
import { Settings } from '../pages/Settings';
import { useAuth } from '../contexts/AuthContext';

// Protected Route wrapper helper
const AdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useAuth();
  if (user?.role !== 'ADMIN') {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
};

export const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Public Auth Routes */}
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Navigate to="/login" replace />} />
      </Route>

      {/* Protected Dashboard Routes */}
      <Route element={<DashboardLayout />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/campaigns" element={<Campaigns />} />
        <Route path="/templates" element={<Templates />} />
        <Route path="/recipients" element={<Recipients />} />
        <Route path="/lists" element={<Lists />} />
        <Route path="/lists/:id" element={<ListDetail />} />
        <Route path="/analytics" element={<Analytics />} />
        
        {/* Admin Only System Settings */}
        <Route 
          path="/settings" 
          element={
            <AdminRoute>
              <Settings />
            </AdminRoute>
          } 
        />
        
        {/* Root Redirect */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
      </Route>

      {/* Catch All Redirect */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
};
export default AppRoutes;
